import { useLove } from './love'
import { useEnter } from './enter'

const FUNCTION_LIST = [useLove, useEnter]

export function directive(app) {
    FUNCTION_LIST.forEach((fun) => {
        fun(app)
    })
}
